import { useEffect, useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || '/api';

const Estrellas = ({ valor }: { valor: number }) => (
  <div className="flex gap-0.5">
    {[1,2,3,4,5].map(i => (
      <span key={i} className={`text-lg ${i <= valor ? 'text-yellow-400' : 'text-gray-300'}`}>★</span>
    ))}
  </div>
);

export default function Resenas() {
  const [resenas, setResenas] = useState([]);
  const [form, setForm] = useState({nombre:'', estrellas:5, comentario:''});
  const [enviado, setEnviado] = useState(false);
  const [mostrarForm, setMostrarForm] = useState(false);

  useEffect(() => {
    axios.get(`${API}/resenas/`).then(r => setResenas(r.data)).catch(() => {});
  }, []);

  const enviar = async (e: any) => {
    e.preventDefault();
    try {
      await axios.post(`${API}/resenas/`, form);
      setEnviado(true);
      setMostrarForm(false);
    } catch {}
  };

  const mockResenas = [
    {id:1, nombre:'Ramón Carrasquel', estrellas:5, comentario:'Increíble servicio y atención. Me asesoraron con total profesionalismo. ¡Los recomiendo al 100%!', creado_en:'2025-02-21'},
    {id:2, nombre:'Gary Barquero', estrellas:5, comentario:'Excelente servicio, coordinación muy rápida. El técnico realizó la instalación en muy buen tiempo. Totalmente recomendados.', creado_en:'2025-02-20'},
    {id:3, nombre:'Karla Chajud', estrellas:5, comentario:'Excelentes precios. El trato súper amable. Servicio express y rápido. ¡Tienen nuevos clientes fijos!', creado_en:'2025-01-22'},
    {id:4, nombre:'Frank Quesada', estrellas:4, comentario:'Me quedé botado un domingo y en una hora me brindaron servicio. Cambio de batería rápido y sin problemas.', creado_en:'2025-02-01'},
  ];

  const data = resenas.length > 0 ? resenas : mockResenas;

  return (
    <section className="bg-white py-20 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <div className="text-rojo text-xs font-bold tracking-widest mb-2">RESEÑAS</div>
          <h2 className="font-condensed text-5xl font-black text-azul mb-3">Nuestros clientes lo confirman</h2>
          <div className="flex items-center justify-center gap-2 mb-6">
            <div className="flex gap-0.5">
              {[1,2,3,4,5].map(i => <span key={i} className="text-yellow-400 text-xl">★</span>)}
            </div>
            <span className="text-gray-500 text-sm font-medium">4.9 / 5 — basado en {data.length}+ reseñas</span>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-5 mb-10">
          {(data as any[]).map((r: any) => (
            <div key={r.id} className="bg-gray-50 border border-gray-100 rounded-2xl p-6 hover:shadow-md hover:border-azul/30 transition-all">
              <div className="flex justify-between items-start mb-4">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-azul rounded-full flex items-center justify-center text-white font-black text-sm flex-shrink-0">
                    {r.nombre.charAt(0)}
                  </div>
                  <div>
                    <div className="font-bold text-azul text-sm">{r.nombre}</div>
                    <div className="text-gray-400 text-xs">{new Date(r.creado_en).toLocaleDateString('es-CR')}</div>
                  </div>
                </div>
                <Estrellas valor={r.estrellas} />
              </div>
              <p className="text-gray-600 text-sm leading-relaxed">{r.comentario}</p>
              <div className="mt-3 flex items-center gap-1 text-xs text-azul font-medium">
                <span>✓</span> <span>Reseña verificada</span>
              </div>
            </div>
          ))}
        </div>

        {/* Botón y formulario */}
        <div className="text-center">
          {!mostrarForm && !enviado && (
            <button onClick={() => setMostrarForm(true)}
              className="bg-azul text-white px-8 py-3 rounded-xl font-bold text-sm hover:bg-azul-dark transition-colors">
              ⭐ Dejar mi reseña
            </button>
          )}
          {enviado && (
            <div className="bg-green-50 border border-green-200 rounded-xl p-6 max-w-md mx-auto">
              <div className="text-3xl mb-2">✅</div>
              <p className="text-green-700 font-bold">¡Gracias por tu reseña!</p>
              <p className="text-green-600 text-sm mt-1">Será revisada y publicada pronto.</p>
            </div>
          )}
          {mostrarForm && (
            <form onSubmit={enviar} className="bg-gray-50 rounded-2xl p-8 max-w-lg mx-auto border border-gray-200 text-left">
              <h3 className="font-condensed text-2xl font-black text-azul mb-6">Dejanos tu reseña</h3>
              <div className="mb-4">
                <label className="text-xs font-bold text-gray-500 tracking-wider block mb-2">TU NOMBRE</label>
                <input required placeholder="Nombre completo" value={form.nombre}
                  onChange={e => setForm({...form, nombre: e.target.value})}
                  className="w-full border border-gray-200 rounded-lg px-4 py-3 text-sm focus:outline-none focus:border-azul"/>
              </div>
              <div className="mb-4">
                <label className="text-xs font-bold text-gray-500 tracking-wider block mb-2">CALIFICACIÓN</label>
                <div className="flex gap-2">
                  {[1,2,3,4,5].map(i => (
                    <button type="button" key={i} onClick={() => setForm({...form, estrellas: i})}
                      className={`text-3xl transition-transform hover:scale-110 ${i <= form.estrellas ? 'text-yellow-400' : 'text-gray-300'}`}>
                      ★
                    </button>
                  ))}
                </div>
              </div>
              <div className="mb-6">
                <label className="text-xs font-bold text-gray-500 tracking-wider block mb-2">TU COMENTARIO</label>
                <textarea required placeholder="Contanos tu experiencia..." value={form.comentario}
                  onChange={e => setForm({...form, comentario: e.target.value})}
                  rows={4} className="w-full border border-gray-200 rounded-lg px-4 py-3 text-sm focus:outline-none focus:border-azul resize-none"/>
              </div>
              <div className="flex gap-3">
                <button type="submit" className="flex-1 bg-azul text-white py-3 rounded-xl font-bold hover:bg-azul-dark transition-colors">
                  Enviar reseña
                </button>
                <button type="button" onClick={() => setMostrarForm(false)}
                  className="px-6 border border-gray-200 rounded-xl text-gray-500 hover:border-gray-400 transition-colors">
                  Cancelar
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </section>
  );
}
